const name = 'stack-tabs';
const dname = 'stackTabsSelected';
const pname = 'price';
const radioInputClass = 'custom-radio__control';

const stackTabs = () => {
  // Stores DOM elements
  const nav = document.getElementById(name);

  if (nav != null) {

    // Helpers functions for price computing
    function _updatePrice() {
      const freq = price.querySelector('button[aria-selected=true]').dataset.freq.toUpperCase();
      const base = +wrapper.querySelector(`#${name}__panels [role=tabpanel][aria-visible=true]`).dataset[`price${freq}`] || 0;
      const radioList = wrapper.querySelectorAll(`#${name}__panels [role=tabpanel][aria-visible=true] .${radioInputClass}:checked`);

      display.innerText = [].reduce.call(radioList, (prev, el) => prev + +el.dataset[`price${freq}`], base);
    }

    // Helper function for keyboard ←→ tab nav
    function _tabNav(direction, tabs, idx) {
      tabs[idx].setAttribute('tabindex', -1);

      if (direction === 'ArrowRight') {
        idx++;
        if (idx >= tabs.length) { idx = 0 }
      }
      if (direction === 'ArrowLeft') {
        idx--;
        if (idx < 0) { idx = tabs.length - 1 }
      }

      tabs[idx].setAttribute('tabindex', 0);
      tabs[idx].focus();

      return idx;
    }

    const wrapper = document.getElementById(`${name}__panels`);
    const tabs = nav.querySelectorAll('[role=tab]');
    const tabpanels = document.querySelectorAll(`#${name}__panels [role=tabpanel]`);

    const price = document.querySelector(`.${pname}`);
    const display = document.getElementById(pname);
    const freqs = price.querySelectorAll('[role=tab]');

    // INIT phase, get currently focused tab and set aria states for depending els
    let tabFocus = Array.prototype.findIndex.call(tabs, e => e.matches('[aria-selected=true]'));

    wrapper.dataset[dname] = tabFocus;
    tabs.forEach((e, i) => e.setAttribute('aria-selected', i === tabFocus))
    tabpanels.forEach((e, i) => {
      e.setAttribute('aria-visible', i === tabFocus);
    });

    let freqFocus = Array.prototype.findIndex.call(freqs, e => e.matches('[aria-selected=true]'));
    _updatePrice();

    // Keyboard and Mouse Events listeners
    nav.addEventListener('keydown', ({ code } = e) => {
      if (code != 'ArrowRight' && code != 'ArrowLeft') { return }
      tabFocus = _tabNav(code, tabs, tabFocus);
    })

    nav.addEventListener('click', ({ target } = e) => {
      if (!target.matches('[role=tab]')) { return }

      tabs.forEach(e => e.matches('[aria-selected=true]') && e.setAttribute('aria-selected', false));

      tabpanels.forEach(e => {
        e.setAttribute('aria-visible', false);
        e.querySelectorAll('input').forEach(e => e.setAttribute('tabindex', '-1'));
      });

      let panel = document.getElementById(target.getAttribute('aria-controls'));

      target.setAttribute('aria-selected', true);
      panel.setAttribute('aria-visible', true);
      panel.querySelectorAll('input').forEach(e => e.removeAttribute('tabindex'));
      wrapper.dataset[dname] = Array.prototype.indexOf.call(tabpanels, panel);

      _updatePrice();
    });

    wrapper.addEventListener('change', e => {
      if (!e.target.classList.contains(radioInputClass)) { return }
      _updatePrice();
    });

    price.addEventListener('keydown', ({ code } =  e) => {
      if (code != 'ArrowRight' && code != 'ArrowLeft') { return }
      freqFocus = _tabNav(code, freqs, freqFocus);
    })

    price.addEventListener('click', ({ target } = e) => {
      if (!target.matches('button[role=tab]')) { return }

      freqs.forEach(e => e.matches('[aria-selected=true]') && e.setAttribute('aria-selected', false));
      target.setAttribute('aria-selected', true);

      _updatePrice();
    });
  }
};

export default stackTabs;
